var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParentshappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#662AB2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1166 28.3916C24.3833 28.6083 23.5166 28.7083 22.5 28.7083H17.5C16.4833 28.7083 15.6166 28.6083 14.8833 28.3916C15.0666 26.225 17.2916 24.5166 20 24.5166C22.7083 24.5166 24.9333 26.225 25.1166 28.3916Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 12.0417H17.5001C13.3334 12.0417 11.6667 13.7084 11.6667 17.8751V22.8751C11.6667 26.0251 12.6167 27.7501 14.8834 28.3917C15.0667 26.2251 17.2917 24.5167 20.0001 24.5167C22.7084 24.5167 24.9334 26.2251 25.1167 28.3917C27.3834 27.7501 28.3334 26.0251 28.3334 22.8751V17.8751C28.3334 13.7084 26.6667 12.0417 22.5001 12.0417ZM20.0001 22.1834C18.3501 22.1834 17.0167 20.8418 17.0167 19.1918C17.0167 17.5418 18.3501 16.2084 20.0001 16.2084C21.6501 16.2084 22.9834 17.5418 22.9834 19.1918C22.9834 20.8418 21.6501 22.1834 20.0001 22.1834Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9833 19.1916C22.9833 20.8416 21.6499 22.1832 19.9999 22.1832C18.3499 22.1832 17.0166 20.8416 17.0166 19.1916C17.0166 17.5416 18.3499 16.2083 19.9999 16.2083C21.6499 16.2083 22.9833 17.5416 22.9833 19.1916Z",
    stroke: "#662AB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentshappy);
export default __webpack_public_path__ + "static/media/parentshappy.e95af2c0ac2e8958e0fbb0b70bff4ed6.svg";
export { ForwardRef as ReactComponent };